var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 17.5 3 C 16.672 3 16 3.672 16 4.5 C 16 4.6761216 16.035954 4.8429605 16.091797 5 L 14 5 L 14 7 L 16.310547 7 L 16.519531 7.5605469 L 12.619141 11 L 9 11 L 9 9 L 12 9 L 12 7 L 2 7 L 2 9 L 4.2402344 9 L 3.7304688 9.4492188 C 2.5804687 10.439219 1 11.8 1 14 C 1 14.27 1.1090625 14.520938 1.2890625 14.710938 L 1.4472656 14.869141 C 1.1853855 15.359439 1.0234375 15.909585 1.0234375 16.5 C 1.0234375 18.418558 2.5945875 20 4.5117188 20 C 6.2579417 20 7.7029312 18.683767 7.9492188 17 L 16.074219 17 C 16.320506 18.683767 17.765496 20 19.511719 20 C 21.42885 20 23 18.418558 23 16.5 C 23 15.033786 22.079411 13.770945 20.791016 13.253906 L 20.695312 13 L 23 13 L 23 11 L 19.945312 11 L 18.070312 6 L 20 6 L 20 3 L 17.5 3 z M 4.5117188 15 C 5.3427564 15 6 15.657134 6 16.5 C 6 17.342866 5.3427564 18 4.5117188 18 C 3.6806811 18 3.0234375 17.342866 3.0234375 16.5 C 3.0234375 15.657134 3.6806811 15 4.5117188 15 z M 19.511719 15 C 20.342756 15 21 15.657134 21 16.5 C 21 17.342866 20.342756 18 19.511719 18 C 18.680681 18 18.023438 17.342866 18.023438 16.5 C 18.023438 15.657134 18.680681 15 19.511719 15 z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScooter);
export default __webpack_public_path__ + "static/media/scooter.303b93d37b24a9869f1d8f3dd42f8db5.svg";
export { ForwardRef as ReactComponent };